import * as React from 'react';
import { CSS, Text } from '@ghq-abi/design-system';
import { ExclamationCircleFillIcon } from '@ghq-abi/design-system-icons';

type ErrorTextProps = {
  children: React.ReactNode;
  css?: CSS;
  iconSize?: number;
  hasIcon?: boolean;
};

export function ErrorText({
  children,
  css,
  iconSize = 24,
  hasIcon = true,
}: ErrorTextProps) {
  return (
    <Text
      css={{
        display: 'flex',
        alignItems: 'center',
        gap: '$sm',
        color: '$gray780',
        ...css,
      }}
    >
      {hasIcon && (
        <ExclamationCircleFillIcon width={iconSize} height={iconSize} />
      )}
      <Text as="span" css={{ flex: 1, fontSize: 'inherit', color: 'inherit' }}>
        {children}
      </Text>
    </Text>
  );
}
